<mat-card class="gsm-form-nachbringen-head_container">
  <h3>Checkliste Nachbringen</h3>
  <mat-accordion class="gsm-form-nachbringen-head_expansion">
    <mat-expansion-panel>
      <mat-expansion-panel-header expandedHeight="40px" collapsedHeight="40px">
        <p *ngIf="aktInfo?.schadenNummer">
          <span class="gsm-form-nachbringen-head_label">Schadennummer: </span>
          <span
          ><a class="schaden-link" href="{{ cockpitUrl }}{{ aktInfo.schadenNummer | formatNumber: 'schaden' }}" target="_blank">{{
              aktInfo.schadenNummer | formatNumber: 'schaden'
            }}</a
          >,
          </span>
        </p>
        <p *ngIf="aktInfo?.kundeVorname && aktInfo?.kundeNachname">
          <span class="gsm-form-nachbringen-head_label">VN-Name: </span>
          <span>{{ aktInfo.kundeVorname + ' ' + aktInfo.kundeNachname }}, </span>
        </p>
        <p *ngIf="aktInfo?.schadenDatum">
          <span class="gsm-form-nachbringen-head_label">Schadendatum: </span>
          <span>{{ aktInfo.schadenDatum | amDateFormat: 'DD.MM.YYYY' }}</span>
        </p>
      </mat-expansion-panel-header>
      <gsm-form-nachbringen-aktinformation [aktInfo]="aktInfo"></gsm-form-nachbringen-aktinformation>
    </mat-expansion-panel>
  </mat-accordion>
</mat-card>
<gsm-form
  *ngFor="let formDefinitionModel of formDefinitionModels"
  [formDefinitionModel]="formDefinitionModel"
  (formChangeEvent)="onFormChange($event, formDefinitionModel.layoutId)"
  (customEventEvent)="customEvent.emit($event)"
>
</gsm-form>
<gsm-upload-progress
  [hidden]="!showUploadProgress"
  [bytesLoaded]="uploadBytesLoaded"
  [bytesTotal]="uploadBytesTotal"
  (cancelEvent)="cancelUpload.emit()"
></gsm-upload-progress>
<button mat-raised-button class="submitBtn" color="primary" [disabled]="(invalid && touched) || isLoading"
        (click)="onSubmit()">
  <span *ngIf="!isLoading">Speichern</span>
  <mat-spinner [diameter]="30" *ngIf="isLoading"></mat-spinner>
</button>
<button mat-raised-button [disabled]="false" (click)="onBackToUebersicht()">
  <span>Zurück zur Übersicht</span>
</button>
